import { motion } from "framer-motion";
import { Star } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];
const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.7, ease: EASE },
};

const TESTIMONIALS = [
  {
    name: "Eduardo Rondon",
    meta: "32 anos · Blumenau — SC",
    quote:
      "Já coloquei em prática e posso confirmar: suas orientações funcionam. Resultado muito acima do que eu esperava!",
  },
  {
    name: "Lodemar Pasold",
    meta: "51 anos · Blumenau — SC",
    quote:
      "Foram 10 kg a menos em 4 meses só ajeitando a alimentação com a ajuda do Lucas. O cardápio é fácil de fazer e não tem erro. O cara sabe o que faz, valeu cada centavo.",
  },
  {
    name: "Tiago Beppler",
    meta: "28 anos · Blumenau — SC",
    quote:
      "Muito atencioso e didático. Já consigo ver resultados nítidos nos primeiros meses de treino. Sempre muito prestativo e tirando toda e qualquer dúvida a todo o momento. Não apenas um treinador, mas um investimento com visão de sucesso.",
  },
];

export default function Testimonials() {
  return (
    <section id="depoimentos" className="section-pad border-t border-white/10">
      <div className="container-x">
        <motion.div {...reveal} className="text-center">
          <p className="overline-label">Depoimentos</p>
          <h2 className="h2-display mt-4 text-white">
            O que dizem
            <br />
            <span className="text-stroke">os alunos.</span>
          </h2>
        </motion.div>

        <div className="mx-auto mt-14 grid max-w-6xl gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: EASE }}
              className="glow-white flex flex-col border border-white/10 bg-card p-7 md:p-8"
            >
              <div className="flex justify-center gap-1.5">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-white text-white" />
                ))}
              </div>
              <blockquote className="mt-7 flex-1 text-center text-sm leading-relaxed text-white/85 md:text-base md:leading-relaxed">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 text-center">
                <p className="font-display text-2xl font-black uppercase tracking-tight text-white">
                  {t.name}
                </p>
                <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
                  {t.meta}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
